import React, { useEffect, useRef } from "react";
import Quill from "quill";

import "quill/dist/quill.snow.css";

const EditorTexto = ({ value = "", onChange }) => {

    const editorRef = useRef(null);
    const quillRef = useRef(null);

    useEffect(() => {

        if (!editorRef.current || quillRef.current) {
            return;
        }

        const quill = new Quill(editorRef.current, {

            theme: "snow",

            modules: {

                toolbar: [

                    [
                        {
                            header: [1, 2, 3, false]
                        }
                    ],

                    ["bold", "italic", "underline", "strike"],

			        [
			            { color: [] },
			            { background: [] }
			        ],


                    [
                        { list: "ordered" },
                        { list: "bullet" }
                    ],

                    [
                        { align: [] }
                    ],

                    ["blockquote"],

                    ["link"],

                    ["clean"]
                ]

            }

        });

        if (value) {
            quill.clipboard.dangerouslyPasteHTML(value);
        }

        quill.on("text-change", () => {

            const html = quill.root.innerHTML;

            if (onChange) {
                onChange(html);
            }

        });

        quillRef.current = quill;

    }, []);

    return (
        <div className="editor-texto">
            <div ref={editorRef}></div>
        </div>
    );
};

export default EditorTexto;